<template>
  <!-- 日次締め -> 劇場前売券/優待券 -> 全レジ金額の内訳計算表 -->
  <el-table
    :data="blendData"
    :span-method="spanMethod"
    :row-class-name="rowClassName"
    class="egl-table all-cash-register-amount-table"
    stripe
    border
  >
    <!-- 種別 -->
    <el-table-column
      prop="type"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.allCashRegisterAmountsTableData.th.ticketType')"
      width="140"
      align="center"
    >
      <template slot-scope="scope">
        <div v-if="scope.row.rowType !== 'total'" :class="[scope.row.rowType === 'subtotal' ? 'sub-total-row' : '' ]">
          {{ accountsReceivableType[scope.row.type] }}
        </div>
        <div v-else>{{ scope.row.type }}</div>
      </template>
    </el-table-column>

    <!-- 売掛金名 -->
    <el-table-column
      prop="name"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.allCashRegisterAmountsTableData.th.accountReceivableName')"
      width="180"
      align="center"
    >
      <template slot-scope="scope">
        {{ scope.row.name }}
      </template>
    </el-table-column>

    <!-- レジ理論件数 -->
    <el-table-column
      prop="qty"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.allCashRegisterAmountsTableData.th.numberOfCashRegisterTheories')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.qty  | separatorFormatter}}</div>
      </template>
    </el-table-column>

    <!-- レジ実件数 -->
    <el-table-column
      prop="actualQty"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.allCashRegisterAmountsTableData.th.actualNumberOfRegistrations')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.actualQty | separatorFormatter }}</div>
      </template>
    </el-table-column>

    <!-- レジ過不足（件数） -->
    <el-table-column
      prop="cashQty"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.allCashRegisterAmountsTableData.th.excessDeficiencyOfRegistration')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.cashQty | separatorFormatter }}</div>
      </template>
    </el-table-column>

    <!-- 日次実件数 -->
    <el-table-column
      prop="dayActualQty"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.allCashRegisterAmountsTableData.th.dayActualQty')"
      align="center"
    >
      <template slot-scope="scope">
        <div v-if="scope.row.rowType === 'subtotal' || scope.row.rowType === 'total'" class="ta-r">
          {{ scope.row.dayActualQty | separatorFormatter }}
        </div>
        <el-input
          v-else
          :value="tableData[scope.row.type][scope.row.index].dayActualQty | separatorFormatter"
          class="ta-r"
          maxlength="10"
          @input="value => inputAction(value, scope.row, 'dayActualQty')"
        ></el-input>
      </template>
    </el-table-column>

    <!-- レジ理論売上 -->
    <el-table-column
      prop="amount"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.allCashRegisterAmountsTableData.th.registrationTheorySales')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.amount | currencyFormatter }}</div>
      </template>
    </el-table-column>

    <!-- レジ実売上 -->
    <el-table-column
      prop="actualAmount"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.allCashRegisterAmountsTableData.th.actualCashRegisterSales')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.actualAmount | currencyFormatter }}</div>
      </template>
    </el-table-column>

    <!-- レジ過不足（売上） -->
    <el-table-column
      prop="cashBalance"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.allCashRegisterAmountsTableData.th.registrationExcessDeficiencySales')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.cashBalance | currencyFormatter }}</div>
      </template>
    </el-table-column>

    <!-- 日次実売上 -->
    <el-table-column
      prop="actualSales"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.allCashRegisterAmountsTableData.th.actualSales')"
      align="center"
    >
      <template slot-scope="scope">
        <template v-if="scope.row.type !== 'settlement'">
          <div class="ta-r">
            {{ scope.row.actualSales | currencyFormatter }}
          </div>
        </template>
        <el-input
          v-else
          :value="tableData[scope.row.type][scope.row.index].actualSales | separatorFormatter"
          maxlength="14"
          class="ta-r"
          @input="value => inputAction(value, scope.row, 'actualSales')"
        ></el-input>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import tranfResData from "@/utils/tranfResData";
import { rounding, digtalParser } from "@/utils/common";
import { ticketDetailResStruct } from "@/assets/js/dailyClosingNew";

export default {
  name: "AllCashAmounts",
  props: {
    accountsReceivableType: {
      type: Object,
      default: () => ({}),
    },
    tableData: {
      type: Object,
      default: () => ({
        couponType: [],
        nationalTicket: [],
        settlement: [],
      }),
    },
    actionType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    blendData() {
      const _values = Object.values(this.tableData).find(_val => _val.length !== 0);
      if (!_values) { return []; }

      const _totalBase = ticketDetailResStruct();
      _totalBase.type = this.$locale("global.total");
      _totalBase.rowType = "total";

      const _tableData = tranfResData(this.tableData);
      let resultArray = [];

      const _addPropFn = (objArray, type) => {
        const _subTotalBase = ticketDetailResStruct();

        objArray.forEach((_item, i) => {
          // const __price = this.receivableListMappingFn(type, _item.settlementId).price || 0;
          // _item.price = __price;
          _item.type = type;
          _item.index = i;

          if (i === 0) {
            _item.rowspan = objArray.length + 1;
            _item.colspan = 1;
          } else {
            _item.rowspan = 0;
            _item.colspan = 0;
          }

          for (let __key in _subTotalBase) {
            if (typeof _item[__key] === "number") {
              _subTotalBase[__key] += _item[__key];
              _totalBase[__key] += _item[__key];
            } else if (__key === "name") {
              _subTotalBase[__key] = this.accountsReceivableType[_item.type] + " " + this.$locale("global.total");
            }
          }
        });

        objArray.push({
          ..._subTotalBase,
          rowType: "subtotal",
          type,
        });

        return objArray;
      };

      Object.keys(_tableData).forEach(_key => {
        if (_tableData[_key].length > 0) {
          const _subList = _addPropFn(_tableData[_key], _key);
          resultArray.push(..._subList);
        }
      });

      resultArray.push(_totalBase);

      return resultArray;
    },
  },
  methods: {
    inputAction(value, rowData, key) {
      let { index, type, amount, qty, actualAmount } = rowData;
      let _value = digtalParser(value);

      if (this.tableData[type] && this.tableData[type][index]) {
        this.tableData[type][index][key] = _value;

        if (key === "dayActualQty") {
          const _actualSales = rounding(amount / qty) * Number(_value);
          this.tableData[type][index].actualSales = _actualSales;
          // this.tableData[type][index].saleQty = (actualAmount - amount) + (_actualSales - actualAmount);
        }
      }
    },
    spanMethod({ row, columnIndex }) {
      const { rowspan, colspan, rowType } = row;

      if (columnIndex === 0) {
        if (rowType === "total") {
          return [1, 2];
        }
        return [rowspan, colspan];
      } else if (columnIndex === 1 && rowType === "total") {
        return [0, 0];
      }
    },
    rowClassName({ row }) {
      // for handle some of the row need to be highlighted in table
      if (row.rowType === "subtotal") {
        return "sub-total-row";
      } else if (row.rowType === "total") {
        return "total-row";
      } else if (row.rowType === "empty-row") {
        return "empty-row";
      }
      return "other-row";
    },
  },
};
</script>